import React from 'react';
import LoginPage from './login/login.component';

const AuthPage = () => {
  return <LoginPage />;
};

export default AuthPage;
